import classes from './pbErrCard.scss';
import { Link } from "react-router-dom";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
const PbErrCard = (props) => {
  let strings=getLocalizedStrings("PbTurnOnPopup");
  let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  let RefreshImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Refresh.svg';
  return (
    <div className={classes.errorBanner}>
    <div class="row">
    <div class="col-xs-12">
    <div className={classes.errorMessageContainer}>
        <div className={classes.errorMessage}>
          <p className={classes.errorImage}><img src={warningImg} alt="Warning Image" /></p>
      
            <div className={classes.group2}>
                <div className={classes.notificationLabel}>
                <span>{strings.errorMsg}</span>
                </div>
            <div className={classes.somethingWrong}>
            <a href="javascript:void(0);" onClick={props.onFormhandler}>{strings.Resubmit}</a>
            </div>
            </div>
        
        </div>
        
      </div>
    </div>
    </div>
    <br />
    
    </div>
  );
};

export default PbErrCard;
